<template>
  <div id="hypetrain">
    <b-card overlay :img-src="gif" class="text-center" img-height="350px">
      <span class="card-header text-center">
        <strong>Hype Train</strong>
      </span>
      <div
        v-if="count == 0"
        @mouseover="
          sendEvent('hypetrain', 'hover', 'hypetrain-non-active-interaction')
        "
      >
        <br /><br />
        <b-img :src="train" width="250" height="150"></b-img>
        <b-list-group flush>
          <b-list-group-item>No active Hype Trains!</b-list-group-item>
          <b-list-group-item>
            <div :style="style">
              <b-container class="text-center">
                <b-button
                  @click="
                    subscribeToUser();
                    sendEvent(
                      'hypetrain',
                      'click',
                      'subscribe-user-hyptrain-btn'
                    );
                  "
                  >Subscribe to {{ channelName }}</b-button
                >
              </b-container>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
      <div v-else>
        <div
          v-if="count < target"
          @mouseover="
            sendEvent('hypetrain', 'hover', 'hypetrain-gauge-interaction')
          "
        >
          <br />
          <gauge
            title="Hype Train"
            :current="count"
            :target="target"
            :colour="gaugeColour"
          ></gauge>
        </div>
        <div v-else>
          <span style="display:none"> {{ (gif = stars) }} </span>
          <b-card-img :src="image"></b-card-img>
          <b-list-group flush>
            <b-list-group-item>Achievement Complete!</b-list-group-item>
            <b-list-group-item>
              <strong>Hype Train Level:</strong>
              {{ level.toLocaleString() }}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Target:</strong>
              {{ target.toLocaleString() }}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Current:</strong>
              {{ count.toLocaleString() }}
            </b-list-group-item>
          </b-list-group>
        </div>
        <br />

        <b-list-group flush>
          <b-list-group-item>
            <div :style="style">
              <b-container class="text-center">
                <b-button
                  @click="
                    subscribeToUser();
                    sendEvent(
                      'hypetrain',
                      'click',
                      'subscribe-user-hyptrain-btn'
                    );
                  "
                  >Subscribe to {{ channelName }}</b-button
                >
              </b-container>
            </div>
          </b-list-group-item>

          <b-list-group-item>
            <strong>Hype Train Level:</strong>
            {{ level }}
          </b-list-group-item>

          <b-list-group-item>
            <b-container class="text-center">
              <div v-if="this.users.length == 0">
                <strong>Featured Contributors</strong>
              </div>
              <div v-else>
                <strong>Featured Contributor:</strong>

                <b-list-group style="max-width: 300px;">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar
                      class="mr-2"
                      :src="displayedContributor.profile"
                      badge
                      badge-top
                      variant="warning"
                      size="3.5em"
                    >
                    </b-avatar>
                    <span class="mr-auto"
                      ><strong>{{
                        displayedContributor.username
                      }}</strong></span
                    >
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-container>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
  </div>
</template>

<script>
import Gauge from "@/components/utils/Gauge.vue";
import ConfigAPI from "@/api/config.js";
import hearts from "@/assets/hearts.gif";
import train from "@/assets/train.png";
import stars from "@/assets/stars.gif";
import trophy from "@/assets/trophy.gif";
import HypeTrainAPI from "@/api/hypetrain.js";
import { clearTimeout, setTimeout, setInterval } from "timers";

export default {
  name: "hypetrain",
  data() {
    return {
      users: [],
      gaugeColour: "#5583c7",
      count: 0,
      target: 1,
      level: 0,
      image: trophy,
      channelName: "",
      ButtonTxtColour: "#FFFFFF",
      ButtonBkgColour: "#5583c7",
      contributorIndex: 0,
      displayedContributor: {
        total: "",
        profile: "",
        plan: "",
        tier: "",
        username: "",
      },

      image: trophy,
      channelName: "",
      id: "",
      // images
      train: train,
      gif: "",
      gifOne: stars,
      gifTwo: hearts,
      trophy: trophy,

      resetTimeout: undefined,
      gifTimeout: undefined,
    };
  },
  mounted() {
    this.setConfig();
    this.getHypeTrain();

    this.channelName = ConfigAPI.getUsername();

    this.eventBus.$on("hypetrain-event", this.hypetrainEvent);
    this.eventBus.$on("hypetrain-update", this.hypetrainUpdate);

    setInterval(this.displayContributor.bind(this), 15000);
  },
  activated: function() {
    ga("set", "page", "/hypetrain");
    ga("send", "pageview");
  },
  methods: {
    setConfig: function() {
      var globalConfig = ConfigAPI.getGlobalConfig();

      if (globalConfig.images) {
        var images = globalConfig.images;
        if (images.one) {
          this.gifOne = images.one;
        }
        if (images.two) {
          this.gifTwo = images.two;
        }
      }

      var config = ConfigAPI.getBroadcasterConfig();
      if (config.hypetrain) {
        var hypetrain = config.hypetrain;
        if (hypetrain.gauge_colour) {
          this.gaugeColour = hypetrain.gauge_colour;
        }
      }

      if (config.panel_settings) {
        var panel = config.panel_settings;
        if (panel.font_colour) {
          this.ButtonTxtColour = panel.font_colour;
        }
        if (panel.background_colour) {
          this.ButtonBkgColour = panel.background_colour;
        }
      }
      return;
    },
    getHypeTrain: function() {
      HypeTrainAPI.getHypeTrain()
        .then((resp) => {
          if (resp.data.count) {
            this.count = resp.data.count;
          }
          if (resp.data.goal) {
            this.target = resp.data.goal;
          }
          if (resp.data.level) {
            this.level = resp.data.level;
          }
          if (resp.data.contributors) {
            this.users = resp.data.contributors;
          }
          if (resp.data.start_date) {
            this.startdate = resp.data.start_date;
          }
          if (resp.data.end_date) {
            this.enddate = resp.data.end_date;
          }
          if (resp.data.contributors) {
            this.users = resp.data.contributors;
            this.displayContributor();
          }
          if (resp.data.id) {
            this.id = resp.data.id;
          }
        })
        .catch((error) => {});
    },
    hypetrainEvent: function(event) {
      this.count = event.total;
      this.target = event.goal;
      this.id = event.id;

      clearTimeout(this.gifTimeout);
      clearTimeout(this.resetTimeout);

      this.gif = this.gifOne;
      this.gifTimeout = setTimeout(
        function() {
          this.gif = this.gifTwo;
        }.bind(this),
        60000
      );

      this.resetTimeout = setTimeout(
        function() {
          this.gif = "";
        }.bind(this),
        120000
      );
    },
    hypetrainUpdate: function(hypetrain) {
      this.count = hypetrain.count;
      this.target = hypetrain.goal;
      this.users = hypetrain.contributors;
    },
    displayContributor: function() {
      if (this.users.length == 0) {
        return;
      }
      if (this.contributorIndex == this.users.length) {
        this.contributorIndex = 0;
      }
      this.displayedContributor = this.users[this.contributorIndex];
      this.contributorIndex++;
    },
    subscribeToUser: function() {
      window.open("https://subs.twitch.tv/" + this.channelName, "_blank");
    },
  },
  computed: {
    style() {
      return {
        "--btnBkgColour": this.ButtonBkgColour,
        "--btnFontColour": this.ButtonTxtColour,
      };
    },
  },
  components: {
    Gauge,
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.card {
  border-color: var(--btnBkgColour);
  border-style: none;
}

.card #followersCard {
  border-style: groove;
}

.card-header {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.b-avatar {
  background: none;
}

.b-avatar .b-avatar-badge {
  background: none;
}
</style>

<style>
.popover {
  max-width: none;
}

.b-avatar {
  background: none;
}

.b-avatar .b-avatar-badge {
  background: none;
}
</style>
